import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { environment } from 'src/environments/environment';

import { Document } from 'src/app/shared/document';
@Component({
  selector: 'app-new-document-dlg-conditions-receipt',
  templateUrl: './new-document-dlg-conditions-receipt.component.html',
  styleUrls: ['./new-document-dlg-conditions-receipt.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgConditionsReceiptComponent implements OnInit, OnChanges, OnDestroy {

  @Input() sNoteLable: string = 'Примечание при выдаче';
  @Input() bNoteLable: string = 'Примечание при приеме';

  @Input() parentDocument: Document = null;

  @Input() newDocument: Document = null;

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  parentDocumentId: number = null;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** NewDocumentDlgConditionsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgConditionsReceiptComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** NewDocumentDlgConditionsReceiptComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

    //  switch (propName) {

    //    case 'parentDocument':
    //      break;
    //  }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgConditionsReceiptComponent in ngOnDestroy')
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgConditionsReceiptComponent in ngOnInit');
  }
}
